export default {
  detail: '详情页面',
  good: '商品详情',
  promo: '活动详情',
};
